import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationState {
  lastSeenAt: string | null;
  markSeen: () => void;
}

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set) => ({
      lastSeenAt: null,
      markSeen: () => set({ lastSeenAt: new Date().toISOString() }),
    }),
    { name: 'loki-notifications' },
  ),
);
